export default __webpack_public_path__ + "static/media/dideban.e0773dae.jpg";